import { Row, Col, Card, Form, Button } from "react-bootstrap";
import React from "react";
import style from "./tools.module.scss";
import AddonNotification from "../../components/common/AddonNotification";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import moment from "moment";
import AlertBs from "../common/AlertBs";

const LeadContent = (props) => {
  const { t } = useTranslation();
  const columns = [
    {
      name: t("Common.name"),
      cell: (row) => `${row.first_name} ${row.last_name}`,
      style: {
        fontWeight: "800", // Apply bold font style to the header cell
      }
    },
    
    {
      name: t("Common.email"),
      selector: (row) => row.email,
      fontWeight: "800", // Apply bold font style to the header cell
      sortable: true,
      right: true,
    },
    {
      name: t("Common.phone"),
      selector: (row) => row.phone,
      fontWeight: "800", // Apply bold font style to the header cell
      right: true,
      sortable: true,
    },
    {
      name: t("Common.date"),
      cell: (row) => moment(row.date).format("D MMM YY-h:mm:ss a"),
      fontWeight: "800", // Apply bold font style to the header cell

      right: true,
      sortable: true,
    },
    
  ];

  return (
    <div className={style.downloadConatiner}>

      <div className={style.userDowmloadSection}></div>


      <Row className="mt-4">
        <Col>
          <Card>
            <Card.Body>
              {/* <Card.Title>
                <span>
                  {t("Common.leadCaptureLink")}:
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={props.lead_url}
                    style={{ textTransform: "lowercase" }}
                  >
                    {props.lead_url}
                  </a>
                </span>
              </Card.Title> */}
              <DataTable
                columns={columns}
                data={props.leads}
                pagination
                paginationPerPage={10}
                searchable
                customStyles={{
                  table: {
                    // Custom styles for the table
                    backgroundColor: "#f2f2f2",
                  },
                  header: {
                    // Custom styles for the table header
                    fontSize: "16px",
                    fontWeight: "bold",
                  },
                  // Add more custom styles as needed
                }}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LeadContent;
